// extracted by mini-css-extract-plugin
export default {"messages__group":"MessagesGroup_messages__group__Pkn+4","messages__group_date":"MessagesGroup_messages__group_date__gzm2y"};